import * as ActionTypes from './types.action';

export const setIsUseDefaultPbb = status => ({
  type: ActionTypes.SET_USE_DEFAULT_PBB_BANK_SUCCESS,
  status,
});
